import React, { FunctionComponent } from "react"

interface DrunkStartupIconProps {
  color?: string
}

const DrunkStartupIcon: FunctionComponent<DrunkStartupIconProps> = ({
  color = "white",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 2C9.20914 2 11 3.79086 11 6C11 8.20914 9.20914 10 7 10C4.79086 10 3 8.20914 3 6C3 3.79086 4.79086 2 7 2Z"
        fill={color}
      />
      <path
        d="M15.6125 5C16.1935 5.48992 21.0034 10.4966 19.5 12C17.9966 13.5034 16.6881 10.8116 14.9998 12.5C13.3116 14.1884 17.2845 17.1374 17.942 17.7949C18.3923 18.2452 18.8646 18.6818 19.2188 19.2131"
        stroke={color}
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.69248 9.74979C3.25548 10.3909 3 11.1656 3 12C3 14.2091 4.79086 16 7 16C9.20914 16 11 14.2091 11 12C11 11.1656 10.7445 10.3909 10.3075 9.74979C9.42607 10.5279 8.26817 11 7 11C5.73183 11 4.57393 10.5279 3.69248 9.74979ZM4.35418 9C5.05931 8.37764 5.98555 8 7 8C8.01445 8 8.94069 8.37764 9.64582 9C8.94069 9.62236 8.01445 10 7 10C5.98555 10 5.05931 9.62236 4.35418 9Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.69248 15.7498C3.25548 16.3909 3 17.1656 3 18C3 20.2091 4.79086 22 7 22C9.20914 22 11 20.2091 11 18C11 17.1656 10.7445 16.3909 10.3075 15.7498C9.42607 16.5279 8.26817 17 7 17C5.73183 17 4.57393 16.5279 3.69248 15.7498ZM4.35418 15C5.05931 14.3776 5.98555 14 7 14C8.01445 14 8.94069 14.3776 9.64582 15C8.94069 15.6224 8.01445 16 7 16C5.98555 16 5.05931 15.6224 4.35418 15Z"
        fill={color}
      />
    </svg>
  )
}

export default DrunkStartupIcon
